// utils/essensStorage.js
import { db } from '../firebase';
import { doc, setDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

export const lagreKodeEssens = async (essensData) => {
  const user = getAuth().currentUser;
  if (!user) {
    console.warn("Bruker ikke logget inn.");
    return;
  }

  try {
    await setDoc(doc(db, "kodeessens", user.uid), essensData);
    console.log("Kode-Essens™ lagret!");
  } catch (error) {
    console.error("Feil ved lagring:", error);
  }
};
